export default function (v) {
    if (v) {
        return { value: v, label: v };
    }
    return v;
}
